const defaultSettings = {
    messageConstants: {
        almeResponseType: "AlmeResponseType",
        appeventRequest: "AppeventRequest",
        converseRequest: "ConverseRequest",
        errorResponseType: "ErrorResponseType",
        extensibleRequest: 'ExtensibleRequest',
        getConfigurationRequest: 'GetConfigurationRequest',
        getHistoryMessageType: "GetHistoryMessageType",
        getHistoryRequest: "GetHistoryRequest",
        getNotificationRequest: "GetNotificationRequest",
        livechatConnectBanner: "LiveChatConnectBanner",
        livechatDisconnectBanner: "LiveChatDisconnectBanner",
        livechatQueuedBanner: 'LiveChatQueuedBanner',
        livechatInputType: 'LiveChatInputType',
        livechatResponseType: "LiveChatResponseType",
        notificationsRequest: 'NotificationsRequest',
        notificationType: "NotificationType",
        reportingEventRequest: 'ReportingEventRequest',
        requestUnitRequest: "RequestUnitRequest",
        userInputType: "UserInputType",
    },
};

export const messageConstants = defaultSettings.messageConstants;
export default defaultSettings;


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/settings/message-constants.ts